// 관리자 페이지 접근 가능 역할
export const ADMIN_ROLES = ['owner', 'admin', 'admin_learner']

// 학습자 페이지 접근 가능 역할
export const LEARNER_ROLES = ['owner', 'admin_learner', 'manager', 'teacher', 'member']

// 모드 전환 가능 역할 (듀얼 역할)
export const DUAL_ROLES = ['owner', 'admin_learner']

export const canAccessAdmin = (role?: string): boolean =>
  role ? ADMIN_ROLES.includes(role.toLowerCase()) : false

export const canAccessLearner = (role?: string): boolean =>
  role ? LEARNER_ROLES.includes(role.toLowerCase()) : false

export const isDualRole = (role?: string): boolean =>
  role ? DUAL_ROLES.includes(role.toLowerCase()) : false

// LC LMS RBAC: 페이지 접근 권한
interface LcAccessLike {
  isOwner?: boolean
  lcPermissions?: string[] | null
}

export const isLcOwner = (user?: LcAccessLike): boolean => !!user?.isOwner

const PAGE_PERMISSION_ALIASES: Record<string, string[]> = {
  CLASS: ['CLASS', 'ENROLLMENT', 'TIMESLOT'],
  STUDENT: ['STUDENT', 'STUDENT_DETAIL', 'ENTRANCE_TEST', 'AIQ_REPORT'],
  CONTENT: ['CONTENT', 'PRODUCT'],
  DASHBOARD: ['DASHBOARD', 'PROGRESS_REPORT', 'NOTIFICATION', 'NOTES'],
}

export const hasLcPermission = (user: LcAccessLike | undefined, permission: string): boolean => {
  if (!user) return false
  if (user.isOwner) return true
  const acceptedPermissions = PAGE_PERMISSION_ALIASES[permission] ?? [permission]
  return acceptedPermissions.some((candidate) => (user.lcPermissions ?? []).includes(candidate))
}

const ADMIN_PAGE_FALLBACKS: Array<[string, string]> = [
  ['DASHBOARD', '/admin'],
  ['COACHING', '/admin/coaching'],
  ['CLASS', '/admin/classes'],
  ['STUDENT', '/admin/members'],
  ['CONTENT', '/admin/contents'],
  ['PERFORMANCE', '/admin/orders'],
  ['MALL', '/admin/mall'],
  ['ANNOUNCEMENT', '/admin/announcements'],
  ['INQUIRY', '/admin/inquiries'],
  ['LIBRARY', '/admin/library'],
  ['DEVICE', '/admin/devices'],
  ['CENTER_INFO', '/admin/settings/center'],
]

export const getLcAdminHomePath = (user?: LcAccessLike): string => {
  if (user?.isOwner) return '/admin'
  return ADMIN_PAGE_FALLBACKS.find(([permission]) => hasLcPermission(user, permission))?.[1] ?? '/admin/profile'
}
